/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_Push_Notifications_To_RInputs */

const en_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable push notifications to receive instant sales alerts, chat inquiries, and domain updates without a broker.`)
};

const es_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilita las notificaciones push para recibir alertas instantáneas de ventas, consultas de chat y actualizaciones de dominio sin intermediarios.`)
};

const fr_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activez les notifications push pour recevoir des alertes de vente instantanées, des demandes de chat et des mises à jour de domaine sans courtier.`)
};

const de_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviere Push-Benachrichtigungen, um sofortige Verkaufsbenachrichtigungen, Chat-Anfragen und Domain-Updates ohne Broker zu erhalten.`)
};

const ja_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知を有効にして、仲介者を介さずに販売アラート、チャットの問い合わせ、ドメインの更新を即座に受け取りましょう。`)
};

const zh_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用推送通知，无需通过中介即可接收即时销售提醒、聊天查询和域名更新。`)
};

const ar_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتمكين الإشعارات الفورية لتلقي تنبيهات المبيعات واستفسارات الدردشة وتحديثات النطاق دون وسطاء.`)
};

const id_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktifkan notifikasi push untuk menerima peringatan penjualan instan, pertanyaan obrolan, dan pembaruan domain tanpa perantara.`)
};

const it_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita le notifiche push per ricevere avvisi di vendita istantanei, richieste di chat e aggiornamenti sul dominio senza intermediari.`)
};

const ru_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включите push-уведомления, чтобы получать мгновенные оповещения о продажах, сообщения в чате и обновления домена без посредников.`)
};

const pt_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilite as notificações push para receber alertas instantâneos de vendas, dúvidas no chat e atualizações de domínio sem intermediários.`)
};

const ko_enable_push_notifications_to_r = /** @type {(inputs: Enable_Push_Notifications_To_RInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림을 활성화하여 브로커 없이 즉각적인 판매 알림, 채팅 문의 및 도메인 업데이트를 받아보세요.`)
};

/**
* | output |
* | --- |
* | "Enable push notifications to receive instant sales alerts, chat inquiries, and domain updates without a broker." |
*
* @param {Enable_Push_Notifications_To_RInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const enable_push_notifications_to_r = /** @type {((inputs?: Enable_Push_Notifications_To_RInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Push_Notifications_To_RInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enable_push_notifications_to_r(inputs)
	if (locale === "es") return es_enable_push_notifications_to_r(inputs)
	if (locale === "fr") return fr_enable_push_notifications_to_r(inputs)
	if (locale === "de") return de_enable_push_notifications_to_r(inputs)
	if (locale === "ja") return ja_enable_push_notifications_to_r(inputs)
	if (locale === "zh") return zh_enable_push_notifications_to_r(inputs)
	if (locale === "ar") return ar_enable_push_notifications_to_r(inputs)
	if (locale === "id") return id_enable_push_notifications_to_r(inputs)
	if (locale === "it") return it_enable_push_notifications_to_r(inputs)
	if (locale === "ru") return ru_enable_push_notifications_to_r(inputs)
	if (locale === "pt") return pt_enable_push_notifications_to_r(inputs)
	return ko_enable_push_notifications_to_r(inputs)
});